import styled, { keyframes } from "styled-components";
import { useLocation, useHistory } from "react-router-dom";
import { SEOHead } from "../components/SEO/SEOHead";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ShareIcon from "@material-ui/icons/Share";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import ReplayOutlinedIcon from "@material-ui/icons/ReplayOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import Reviews from "../components/Reviews/Reviews";
import { Chip, IconButton, Tabs, Tab } from "@mui/material";
import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import Tooltip from "@material-ui/core/Tooltip";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import parse from 'html-react-parser';

import facebookIcon from "../assets/img/facebook.png";
import twitterIcon from "../assets/img/twitterIcon.png";
import linkedInIcon from "../assets/img/linkedIn.png";

import { publicRequest } from "../api/requestMethods";
import { addToCart } from "../redux/cartRedux";
import Announcement from "../components/Announcement";
import Navbar from "../components/Navbar";
/* THE one product media viewer. This page used to carry its own copy of
   BrandProductPage's ZoomGallery, teal accent and all; the copy is gone and
   the accent is a prop. */
import ProductImageGallery from "../components/ProductImageGallery";
import { mobile } from "../responsive";
import useStyles from "../components/styles/listingStyle.js";
import { COUNTRY_NAME, formatCurrency, SITE_ORIGIN } from "../config/market";

/* ── Layout primitives ───────────────────────────────────────────────────
   Amazon-inspired detail page: a 2-column grid (gallery / buy-box) above
   a full-width tabbed information area. Sized for big desktop monitors
   but degrades to a single column under 980px. */
const PageShell = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: var(--lusuku-nav-h, 100px) 24px 60px;
  ${mobile({ padding: "var(--lusuku-nav-h, 110px) 12px 40px" })}
`;

const Breadcrumb = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 0.85rem;
  color: #64748b;
  margin-bottom: 14px;
`;

const BreadLink = styled.button`
  background: none;
  border: none;
  color: #135d69;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  &:hover { text-decoration: underline; }
`;

const BreadSep = styled.span`color: #cbd5e1;`;
const BreadCurrent = styled.span`color: #475569; max-width: 320px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;`;

const PageGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) minmax(280px, 0.65fr);
  gap: 28px;
  align-items: start;
  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const GalleryCol = styled.div`
  position: sticky;
  top: 90px;
  @media (max-width: 760px) { position: static; }
`;


const CenterCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  margin: 0;
  ${mobile({ fontSize: "1.3rem" })}
`;

const MetaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 0.85rem;
  color: #475569;
`;

const Stars = styled.span`
  display: inline-flex;
  align-items: center;
  color: #f59e0b;
  svg { width: 16px; height: 16px; }
`;

const LinkLikeBtn = styled.button`
  background: none;
  border: none;
  color: #135d69;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  font-size: 0.85rem;
  &:hover { text-decoration: underline; }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #eef2f7;
  margin: 4px 0;
`;

const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
`;


const PriceAmount = styled.span`
  font-size: 2.1rem;
  font-weight: 800;
  color: #b91c1c;
  line-height: 1;
`;

const PriceUnit = styled.span`
  color: #64748b;
  font-size: 0.85rem;
`;

const BulletsTitle = styled.h3`
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
  margin: 6px 0 4px;
`;

const BulletList = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: #334155;
  font-size: 0.9rem;
  line-height: 1.6;
  li { margin-bottom: 4px; }
`;

/* Buy box: Amazon's right-rail card. Sticky on desktop so add-to-cart
   stays visible as the buyer scrolls long descriptions. */
const BuyBox = styled.aside`
  position: sticky;
  top: 90px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  padding: 18px 18px 16px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media (max-width: 1100px) {
    grid-column: 1 / -1;
    position: static;
  }
`;

const BuyBoxPrice = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
`;

const StockText = styled.div`
  font-size: 0.95rem;
  font-weight: 700;
  color: ${(p) => (p.$ok ? "#15803d" : "#b91c1c")};
`;

const DeliveryNote = styled.div`
  font-size: 0.82rem;
  color: #475569;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  svg { width: 18px; height: 18px; color: #135d69; flex-shrink: 0; margin-top: 1px; }
  strong { color: #0f172a; }
`;

const QtyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
  color: #475569;
`;

const QtySelect = styled.select`
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  &:focus { outline: 2px solid #135d69; outline-offset: 1px; }
`;

const pulse = keyframes`
  0%{box-shadow:0 0 0 0 rgba(19,93,105,0.35)}
  70%{box-shadow:0 0 0 10px rgba(19,93,105,0)}
  100%{box-shadow:0 0 0 0 rgba(19,93,105,0)}
`;

const PrimaryCta = styled.button`
  width: 100%;
  padding: 13px 16px;
  background: linear-gradient(180deg, #f5d042 0%, #f0b400 100%);
  border: 1px solid #d99e00;
  color: #1a1a2e;
  font-weight: 800;
  font-size: 0.95rem;
  border-radius: 999px;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.15s ease;
  &:hover { filter: brightness(0.97); }
  &:active { transform: translateY(1px); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const SecondaryCta = styled.button`
  width: 100%;
  padding: 13px 16px;
  background: linear-gradient(180deg, #135d69 0%, #0e4951 100%);
  border: 1px solid #0c3a40;
  color: #fff;
  font-weight: 800;
  font-size: 0.95rem;
  border-radius: 999px;
  cursor: pointer;
  animation: ${pulse} 2.4s ease-out 0.4s 2;
  transition: filter 0.15s ease, transform 0.15s ease;
  &:hover { filter: brightness(1.07); }
  &:active { transform: translateY(1px); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const InCartChipWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SecureRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: #15803d;
  svg { width: 14px; height: 14px; }
`;

const TrustGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 4px;
`;

const TrustItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
  padding: 8px 6px;
  border-radius: 10px;
  background: #f8fafc;
  font-size: 0.7rem;
  color: #475569;
  font-weight: 600;
  svg { width: 22px; height: 22px; color: #135d69; }
`;

const InfoSection = styled.section`
  margin-top: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
`;

const TabBar = styled.div`
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  .MuiTabs-flexContainer { gap: 4px; }
  .MuiTab-root {
    text-transform: none;
    font-weight: 600;
    font-size: 0.9rem;
    min-height: 48px;
    color: #475569;
  }
  .Mui-selected { color: #135d69 !important; }
  .MuiTabs-indicator { background-color: #135d69 !important; height: 3px; border-radius: 3px 3px 0 0; }
`;

const TabBody = styled.div`
  padding: 22px 24px;
  min-height: 220px;
  font-size: 0.95rem;
  color: #1f2937;
  line-height: 1.7;
  ${mobile({ padding: "16px" })}
`;

const MutedNote = styled.p`
  font-style: italic;
  color: #64748b;
  margin: 0;
`;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const formatPrice = (n) =>
  n == null || Number.isNaN(Number(n)) ? "—" : formatCurrency(n);

const Product = () => {
  const cart = useSelector((state) => state.cart.products);
  const location = useLocation();
  const history = useHistory();
  const id = location.pathname.split("/")[2];
  const [product, setProduct] = useState({});
  const [qty, setQty] = useState(1);

  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [activeTab, setActiveTab] = useState('description');
  const classes = useStyles();

  const dispatch = useDispatch();

  useEffect(() => {
    const getProduct = async () => {
      try {
        const res = await publicRequest.get(`/posts/listing/${id}`);
        setProduct(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getProduct();
  }, [id]);

  /* Build a deduped image list. The legacy listing schema only carries
     a single `product_image`, but newer records may include
     `additionalImages` — so we accept both and gracefully fall back. */
  const galleryImages = useMemo(() => {
    const out = [];
    if (product?.product_image) out.push(product.product_image);
    if (Array.isArray(product?.additionalImages)) {
      product.additionalImages.forEach((u) => {
        if (typeof u === "string" && u && !out.includes(u)) out.push(u);
      });
    }
    return out;
  }, [product]);

  /* Strip HTML so we can derive a short list of "About this item" bullets
     from the description without rendering tags inside a UL. We split on
     line breaks and bullets/dashes; if nothing useful exists we fall back
     to a single trimmed sentence. */
  const aboutBullets = useMemo(() => {
    if (!product?.description) return [];
    const text = String(product.description).replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ");
    const parts = text
      .split(/\n|•|·|—|\s-\s|;/)
      .map((s) => s.trim())
      .filter((s) => s.length > 8 && s.length < 220);
    return parts.slice(0, 5);
  }, [product]);

  const inStock = (product?.countInStock ?? 0) > 0;
  const stockNum = Number(product?.countInStock) || 0;

  const addToCartHandler = (item) => {
    dispatch(addToCart({ item }));
  };

  const buyNow = (item) => {
    if (!item?._id) return;
    dispatch(addToCart({ item }));
    history.push('/cart');
  };

  const isInCart = (prod) => {
    return Boolean(
      cart?.some((item) => item?._id === prod?._id)
    );
  };

  // Soc Share
  const handleShareDialogOpen = () => {
    setShareDialogOpen(true);
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  };

  const shareOnSocialMedia = (platform) => {
    const productLink = `${SITE_ORIGIN}/product/${id}`;

    let newWindow;

    switch (platform) {
      case "facebook":
        // Share on Facebook
        const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          productLink
        )}`;
        newWindow = window.open(
          facebookShareUrl,
          "_blank",
          "noopener,noreferrer"
        );
        break;
      case "twitter":
        // Share on Twitter
        const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          productLink
        )}`;
        newWindow = window.open(
          twitterShareUrl,
          "_blank",
          "noopener,noreferrer"
        );
        break;
      case "linkedin":
        // Share on LinkedIn
        const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          productLink
        )}`;
        newWindow = window.open(
          linkedinShareUrl,
          "_blank",
          "noopener,noreferrer"
        );
        break;
      // Add more cases for other social media platforms
      default:
        break;
    }

    if (!newWindow) {
      alert(
        "A popup blocker may have prevented the share window from opening. You can disable the popup blocker and try again."
      );
    }

    // Close the share dialog
    handleShareDialogClose();
  };

  const copyProductLink = () => {
    const productLink = `${SITE_ORIGIN}/product/${id}`;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(productLink).then(
        () => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        },
        () => {
          console.error("Failed to copy product link to clipboard.");
        }
      );
    } else {
      // Fallback or show warning message.
      window.alert(
        "Sorry, your browser does not support copying. Please copy the link manually."
      );
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setCopied(false);
  };

  // Function to handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Conditionally check if the description contains HTML tags as old records are plain strings
  function createMarkup(htmlContent) {
    return { __html: htmlContent };
  }

  const productInCart = isInCart(product);
  const centerColRef = useRef(null);

  return (
    <>
      <SEOHead
        title={product?.title || product?.name || 'Product'}
        description={product?.description ? String(product.description).replace(/<[^>]+>/g, '').slice(0, 160) : `Shop ${product?.title || 'this product'} on Lusuku. Fast delivery across ${COUNTRY_NAME}.`}
        imageUrl={product?.product_image || product?.imageUrl}
        canonicalPath={`/product/${id}`}
        type="product"
        keywords={
          product?.tags?.length > 0
            ? product.tags
            : [product?.title || product?.name].filter(Boolean)
        }
        product={product?._id ? { _id: product._id, name: product.title || product.name, price: product.price, imageUrl: product.product_image || product.imageUrl, vendorName: 'Lusuku' } : null}
      />
      <Navbar />
      <PageShell>
        <div style={{ padding: "0 0 16px" }}>
          <Announcement />
        </div>

        {/* Breadcrumb */}
        <Breadcrumb>
          <BreadLink onClick={() => history.push('/')}>Home</BreadLink>
          <BreadSep>/</BreadSep>
          <BreadLink onClick={() => history.push('/shop')}>Shop</BreadLink>
          <BreadSep>/</BreadSep>
          <BreadCurrent>{product?.title || ""}</BreadCurrent>
        </Breadcrumb>

        <PageGrid>
          {/* LEFT — Image gallery with zoom */}
          <GalleryCol>
            <ProductImageGallery
              images={galleryImages}
              videos={product?.videos}
              alt={product?.title}
              detailRef={centerColRef}
              hoverZoom
              lightbox
              accent="#135d69"
              lensTint="rgba(19, 93, 105, 0.12)"
              mainHeight="520px"
              mobileMainHeight="340px"
              /* This page's own collapse points, not the platform default,
                 and the one place where the rail and the stage part company.
                 The rail has room to stay vertical down to 640px; the stage
                 has to shorten at 850px, which is the `mobile` helper every
                 other rule on this page uses. 1100px is exactly where
                 PageGrid above drops from three columns to two and CenterCol,
                 which the magnified panel is measured against, stops sitting
                 beside the gallery. */
              railBreakpoint={640}
              stageHeightBreakpoint={850}
              zoomPanelBreakpoint={1100}
            />
          </GalleryCol>

          {/* CENTER — Title, price, bullets */}
          <CenterCol ref={centerColRef}>
            <Title>{product?.title || <span style={{ color: "#cbd5e1" }}>Loading…</span>}</Title>

            <MetaRow>
              <Stars aria-label="No reviews yet">
                {[0, 1, 2, 3, 4].map((i) => (<StarBorderIcon key={i} />))}
              </Stars>
              <LinkLikeBtn onClick={() => setActiveTab('reviews')}>Be the first to review</LinkLikeBtn>
              {product?.tags?.length > 0 && (
                <>
                  <span style={{ color: "#cbd5e1" }}>•</span>
                  <span style={{ color: "#64748b" }}>{product.tags.slice(0, 3).join(" · ")}</span>
                </>
              )}
            </MetaRow>

            <Divider />

            <PriceRow>
              <PriceAmount>{formatPrice(product?.price)}</PriceAmount>
              {(product?.measurements || product?.unit_id?.unit) && (
                <PriceUnit>per {product?.measurements || ""} {product?.unit_id?.unit || "unit"}</PriceUnit>
              )}
            </PriceRow>

            <SecureRow>
              <LockOutlinedIcon />
              <span>Secure transaction</span>
            </SecureRow>

            <Divider />

            {aboutBullets.length > 0 && (
              <>
                <BulletsTitle>About this item</BulletsTitle>
                <BulletList>
                  {aboutBullets.map((b, i) => (<li key={i}>{b}</li>))}
                </BulletList>
              </>
            )}

            {/* Trust strip */}
            <TrustGrid>
              <TrustItem>
                <LocalShippingOutlinedIcon />
                <span>Fast delivery across {COUNTRY_NAME}</span>
              </TrustItem>
              <TrustItem>
                <VerifiedUserOutlinedIcon />
                <span>Verified vendor</span>
              </TrustItem>
              <TrustItem>
                <ReplayOutlinedIcon />
                <span>Easy returns</span>
              </TrustItem>
            </TrustGrid>
          </CenterCol>

          {/* RIGHT — Buy box */}
          <BuyBox>
            <BuyBoxPrice>{formatPrice(product?.price)}</BuyBoxPrice>

            <DeliveryNote>
              <LocalShippingOutlinedIcon />
              <span>
                <strong>FREE delivery</strong> on orders over {formatCurrency(500000)} — typically 1–3 business days.
              </span>
            </DeliveryNote>

            <StockText $ok={inStock}>
              {inStock
                ? stockNum > 10
                  ? "In Stock"
                  : `Only ${stockNum} left in stock!`
                : "Out of Stock"}
            </StockText>

            {inStock && (
              <QtyRow>
                <span>Qty:</span>
                <QtySelect value={qty} onChange={(e) => setQty(Number(e.target.value))}>
                  {Array.from({ length: Math.min(stockNum || 1, 10) }, (_, i) => i + 1).map((n) => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </QtySelect>
              </QtyRow>
            )}

            {productInCart ? (
              <InCartChipWrap>
                <Chip label="In Cart" color="success" size="small" />
                <LinkLikeBtn onClick={() => history.push('/cart')}>View cart →</LinkLikeBtn>
              </InCartChipWrap>
            ) : (
              <>
                <PrimaryCta
                  onClick={() => addToCartHandler(product)}
                  disabled={!inStock || !product?._id}
                >
                  Add to Cart
                </PrimaryCta>
                <SecondaryCta
                  onClick={() => buyNow(product)}
                  disabled={!inStock || !product?._id}
                >
                  Buy Now
                </SecondaryCta>
              </>
            )}

            <Divider />

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "0.82rem", color: "#475569" }}>
              <span>Sold by <strong style={{ color: "#0f172a" }}>Lusuku</strong></span>
              <Tooltip title="Share">
                <IconButton size="small" onClick={handleShareDialogOpen}>
                  <ShareIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          </BuyBox>
        </PageGrid>

        {/* ── Information area (tabs) ───────────────────────────────── */}
        <InfoSection>
          <TabBar>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Description" value="description" />
              <Tab label="Specification" value="specification" />
              <Tab label="Reviews" value="reviews" />
              <Tab label="Shipping Policy" value="shippingReturns" />
              <Tab label="Offers & Discounts" value="moreOffers" />
            </Tabs>
          </TabBar>
          <TabBody>
            {activeTab === 'description' && (
              product?.description
                ? <div dangerouslySetInnerHTML={createMarkup(product.description)} />
                : <MutedNote>No description provided.</MutedNote>
            )}
            {activeTab === 'specification' && (
              <MutedNote>No product specifications listed yet.</MutedNote>
            )}
            {activeTab === 'reviews' && (
              product?._id
                ? <Reviews subjectType="product_inhouse" subjectId={product._id} title="Customer reviews" />
                : <MutedNote>Loading reviews…</MutedNote>
            )}
            {activeTab === 'shippingReturns' && (
              product?.returnPolicy
                ? <div>{parse(String(product.returnPolicy))}</div>
                : <MutedNote>Standard Lusuku shipping & return policy applies.</MutedNote>
            )}
            {activeTab === 'moreOffers' && (
              <MutedNote>This product has no special offers currently.</MutedNote>
            )}
          </TabBody>
        </InfoSection>

        {/* Share dialog */}
        <Dialog open={shareDialogOpen} onClose={handleShareDialogClose} aria-labelledby="share-dialog-title">
          <DialogTitle id="share-dialog-title">Share Product</DialogTitle>
          <DialogContent>
            <DialogContentText>Share this product with others:</DialogContentText>
            <Snackbar
              open={copied}
              autoHideDuration={6000}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert onClose={handleClose} severity="success">
                Product link copied to clipboard.
              </Alert>
            </Snackbar>
            <Button
              className={classes.shareButton}
              startIcon={<img src={facebookIcon} alt="Facebook" style={{ width: 24, height: 24, objectFit: "contain" }} />}
              onClick={() => shareOnSocialMedia("facebook")}
            >Facebook</Button>
            <Button
              className={classes.shareButton}
              startIcon={<img src={twitterIcon} alt="Twitter" style={{ width: 21, height: 21, objectFit: "contain" }} />}
              onClick={() => shareOnSocialMedia("twitter")}
            >Twitter</Button>
            <Button
              className={classes.shareButton}
              startIcon={<img src={linkedInIcon} alt="LinkedIn" style={{ width: 23, height: 23, objectFit: "contain" }} />}
              onClick={() => shareOnSocialMedia("linkedin")}
            >LinkedIn</Button>
            <Button
              className={classes.shareButton}
              startIcon={<FileCopyIcon />}
              onClick={copyProductLink}
            >Copy Link</Button>
          </DialogContent>
        </Dialog>
      </PageShell>
    </>
  );
};

export default Product;
